// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "main.1c0227f3.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"316":"3209520d","328":"a76d6d85","675":"f6e428ab","861":"1fc2e9ba"}[chunkId] + ".chunk.css";
};